import { z } from "zod";

import { normalizeHistoryFields } from "../utils";
import type { UpdateCaseInput } from "./inputs";

export const CaseHistoryField = z.enum([
  "client",
  "branch",
  "case_type",
  "external_identifier",
  "claimant_vehicle",
  "liable_vehicle",
  "liable_vehicles",
  "incident",
  "contacts",
  "damages",
  "debt",
  "payment",
  "prescription_period",
]);
export type CaseHistoryField = z.infer<typeof CaseHistoryField>;

type CaseHistoryFieldByKey = Record<keyof UpdateCaseInput, CaseHistoryField | null> &
  Record<string, CaseHistoryField | null | undefined>;

const CASE_HISTORY_FIELD_BY_KEY: CaseHistoryFieldByKey = {
  clientId: "client",
  branchId: "branch",
  externalCode: "external_identifier",
  incident: "incident",
  prescriptionPeriodYears: "prescription_period",
  liableVehicles: "liable_vehicles",
  vehicle: "claimant_vehicle",
  contacts: "contacts",
  damages: "damages",
  debt: "debt",
  paymentPlan: "payment",
  archiveContactId: "contacts",
  reactivateArchivedContacts: null,
  expectedUpdatedAt: null,
  caseType: "case_type",
  liableVehicle: "liable_vehicle",
};

export const normalizeCaseHistoryFields = (keys: readonly string[]) =>
  normalizeHistoryFields(keys, CaseHistoryField, CASE_HISTORY_FIELD_BY_KEY);
